import React from 'react'
import { Container } from 'reactstrap'

import allanMyers from '../../images/clients/allan-myers.webp'
import houseSetter from '../../images/clients/house-setter.webp'
import orases from '../../images/clients/orases.webp'
import tbl from '../../images/clients/tbl.webp'
import ams from '../../images/clients/ams.webp'
import medicalPassport from '../../images/clients/one-medical-logo.svg'
import mp from '../../images/clients/mp-logo.webp'
import nascate from '../../images/clients/nascate.webp'

const ITEMS = [
  {
    icon: allanMyers,
    className: 'allanMyers',
  },
  {
    icon: houseSetter,
    className: 'houseSetter',
  },
  {
    icon: ams,
    className: 'ams',
  },
  {
    icon: tbl,
    className: 'tbl',
  },
  {
    icon: orases,
    className: 'orases',
  },
  {
    icon: medicalPassport,
    className: 'medicalPassport',
  },
  {
    icon: mp,
    className: 'mp',
  },
  {
    icon: nascate,
    className: 'nascate',
  },
]

const Clients = () => {
  return (
    <section className="Clients">
      <Container>
        <h3 className="Clients__title">
          <span className="text-blue">Our</span> Clients
        </h3>

        <ul className="Clients__list">
          {ITEMS.map(({ icon, className }, idx) => (
            <li key={idx}>
              <img src={icon} alt={className} className={className} width="182" height="50" />
            </li>
          ))}
        </ul>
      </Container>
    </section>
  )
}

export default Clients
